import { useDebugValue } from 'react';
import { useTranslation } from 'react-i18next';

import { useQuery, useMutation } from '@app/QueryClient';
import { generatedKeys } from '@app/data';
import {
	createDiscount,
	deleteDiscount,
	updateDiscount,
	listGiftDiscount,
} from '@services/GiftFriend';

const { giftFriend } = generatedKeys;

export function useGiftDiscount(opt: any) {
	const q = useQuery({
		queryFn: listGiftDiscount,
		staleTime: Infinity,
		queryKey: giftFriend.discount({
			id: opt?.id,
		}),
		enabled: !!opt?.id,
		retry: false,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		cacheTime: 0,
	});

	useDebugValue(q);

	return q;
}

export function useAddDiscount(opt: any) {
	const { t } = useTranslation('giftfriend');

	const mutation = useMutation(createDiscount, {
		...opt,
		moduleName: t('discount'),
		operation: 'add',
	});

	const { mutate } = mutation;

	return {
		...mutation,
		doAddDiscount: mutate,
	};
}

export function useEditDiscount(opt: any) {
	const { t } = useTranslation('giftfriend');

	const mutation = useMutation(updateDiscount, {
		...opt,
		moduleName: t('discount'),
		operation: 'update',
	});

	const { mutate } = mutation;

	return {
		...mutation,
		doEditDiscount: mutate,
	};
}

export function useDeleteDiscount(opt: any) {
	const { t } = useTranslation('giftfriend');

	const mutation = useMutation(deleteDiscount, {
		...opt,
		moduleName: t('discount'),
		operation: 'delete',
	});

	const { mutateAsync } = mutation;

	return {
		...mutation,
		doDeleteDiscount: mutateAsync,
	};
}
